import { MESSAGES } from '@guuru/chat-common';
import {
  appendLocalMessage,
  ChatAPI,
  replaceLastLocalMessage,
} from '@guuru/chat-web';
import events from '@guuru/events-web';
import { delay as sleep } from '@guuru/helpers-common';

const requestCategory = 'bot:::requestCategory';

const addBotRequestCategory = (categories, delay = true) =>
  sleep(delay ? ChatAPI.getBotEllipsisMessageDelay() : 0).then(() => {
    const message = ChatAPI.messages.createBotMessage(
      Date.now(),
      requestCategory,
      MESSAGES.category,
      { categories },
      true,
      false,
    );
    if (
      Object.keys(categories).length === 0 &&
      categories.constructor === Object
    ) {
      ChatAPI.pushPendingMessages(message);
    }
    return message;
  });

export default {
  async validate(partnerId) {
    const { priority } = ChatAPI.storeRetrieveParams();
    if (priority === 'bot') {
      return false;
    }

    const { category: validCategory } =
      await ChatAPI.getChatSettings(partnerId);
    if (validCategory?.id) {
      ChatAPI.storeCategory(validCategory.id);
      return false;
    }

    const categorySelected = ChatAPI.storeRetrieveCategorySelected();
    if (categorySelected) {
      return false;
    }

    const category = ChatAPI.storeRetrieveCategory();
    return !category;
  },
  async render(partnerId) {
    const { categories } = await ChatAPI.getChatSettings(partnerId);
    const enabledCategories = categories.filter((cat) => cat.isActive);

    events.requestCategory();
    const requestCategoryMessage =
      await addBotRequestCategory(enabledCategories);
    appendLocalMessage(requestCategoryMessage);
    return {};
  },

  async processResponse(_, { category, categoryLabel }) {
    const requestCategoryMessage = await addBotRequestCategory({}, false);
    replaceLastLocalMessage(requestCategoryMessage);
    const message = ChatAPI.addCategory(category, categoryLabel);
    events.categorySubmitted(category);

    appendLocalMessage(message);
  },
};
